import { nanoid } from "nanoid";
import { decrypt } from "./encryption";

export const getFirstName = (name: string) => {
  return name.split(" ")[0];
};

export const handleLogin = (
  response: any,
  setUserDetails: any,
  source?: string,
  setSource?: any
) => {
  const encryptedData = response?.data?.data;
  localStorage.setItem("userDetails", encryptedData);
  source && localStorage.setItem("source", source);
  setUserDetails({ ...JSON.parse(decrypt(encryptedData)) });
  setSource && setSource(source);
};

export const capitalize = (str: string) => {
  if (!str) return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const roundOff = (num: number, roundOffDigit: number = 2) => {
  return typeof num == "number" && !Number.isInteger(num)
    ? Number(num.toFixed(2))
    : num;
};

export const sanitizeUserInputQuery = (input: string) => {
  return input
    .replace(/db\.\w+\.\w+\(.*?\)/gi, "")
    .replace(/db\.\w+\(\)/gi, "")
    .replace(
      /(\{\s*)?\$\w+\s*:\s*(\{[^}]*\}|\d+|".*?"|'.*?'|`.*?`|‘.*?‘)(\s*\})?/gi,
      ""
    );
};

export const validateEmail = (email: string) => {
  const reg: RegExp =
    /^([A-Za-z0-9_\-\\.])+@([A-Za-z0-9_\-\\.])+\.([A-Za-z]{2,4})$/;
  return reg.test(email);
};

export const getNewChat = () => {
  return { sessionId: nanoid(), title: "New chat", conversations: [] };
};

// Helper to convert Title Case from Sanke Case
export function toTitleCaseFromSnake(input: string): string {
  return input
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

// Helper to convert JSON to Markdown table string
export const jsonToTableMarkdown = (data: any) => {
  const headers = Object.keys(data[0] || {}).join(" | ");
  const separator = Object.keys(data[0] || {})
    .map(() => "---")
    .join(" | ");
  const rows = data
    .map((row: any) => Object.values(row).join(" | "))
    .join("\n");

  return `| ${headers} |\n| ${separator} |\n| ${rows} |`;
};
